<template>
    <div>
        <p class="info-label">{{ $l10n.__('Etat du compte') }}</p>
        <CompassTag size="small" :color="information.color" :icon="information.icon">
            {{ translation }}
        </CompassTag>
    </div>
</template>

<script>
import { bankStatus } from 'Dictionaries/statusColors';

export default {
    props: {
        status: {
            type: String,
            default: '',
        },
    },
    computed: {
        information() {
            return bankStatus[this.status];
        },

        translation() {
            const translation = {
                error: this.$l10n.__('Erreur de synchronisation'),
                manual: this.$l10n.__('Manuel'),
                deleted: this.$l10n.__('Supprimé'),
                connected: this.$l10n.__('Synchronisé'),
                disconnected: this.$l10n.__('Désactivé'),
            };
            return translation[this.status];
        },
    },
};
</script>
